<script setup>
import VueMultiselect from "vue-multiselect";
import Avatar from "@/components/ui/Avatar.vue";
import {computed} from "vue";
const props = defineProps(['value', 'options', 'multiple', 'addClass']);
const emit = defineEmits(['input']);

const user = computed({
    get: () => props.value,
    set: (value) => emit('input', value)
});
</script>

<template>
    <VueMultiselect
        v-model="user"
        :options="options"
        class="multiselect--white"
        :class="addClass"
        select-label=""
        deselect-label=""
        :multiple="multiple"
        label="name"
        track-by="name"
    >
        <template slot="option" slot-scope="props">
            <template v-if="props.option.type === 'group'">
                <div class="d-flex align-items-center">
                    <div class="mr-2">
                        <font-awesome-icon :icon="['fa', 'users']" size="lg"  />
                    </div>
                    {{ props.option.name }}
                </div>
            </template>

            <template v-else>
                <div class="d-flex align-items-center">
                    <div class="mr-2">
                        <Avatar
                            :username="props.option.name"
                            :src="props.option.avatar"
                            :size="30">
                        </Avatar>
                    </div>
                    {{ props.option.name }}
                </div>
            </template>
        </template>
    </VueMultiselect>
</template>

<style scoped>

</style>
